var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_30-cooking_book"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28 56h-27v-2s8-3 15-3c7.07 0 12 5 12 5z",
    fill: "#918778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63 54v2h-27s4.93-5 12-5c7 0 15 3 15 3z",
    fill: "#918778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 60h50v3h-50z",
    fill: "#733125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 56v4h-50v-4h21c0-1.11 1.79-2 4-2s4 .89 4 2z",
    fill: "#da684e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 10.5v.18a19.606 19.606 0 0 0 -3 2.29v-2.47a1.5 1.5 0 0 1 3 0z",
    fill: "#da684e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 1v10.87c-2.79-1.72-7.21-3.87-12-3.87a16.946 16.946 0 0 0 -9 2.68v-.18a1.5 1.5 0 0 0 -3 0v2.47a12.821 12.821 0 0 0 -1 1.03s-5-6-13-6c-4.79 0-9.21 2.15-12 3.87v-10.87z",
    fill: "#da684e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 51v3c-2.21 0-4 .89-4 2 0 0-4.93-5-12-5-7 0-15 3-15 3v-37l3-2v34a27.145 27.145 0 0 1 13-3c8 0 15 5 15 5z",
    fill: "#ded0b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63 17v37s-8-3-15-3c-7.07 0-12 5-12 5 0-1.11-1.79-2-4-2v-3s7-5 15-5a27.145 27.145 0 0 1 13 3v-34z",
    fill: "#eddebf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 31c-2.76 0-5 1.24-5 4a5 5 0 0 0 10 0c0-2.76-2.24-4-5-4zm-1.31-7h5.54a2.783 2.783 0 0 0 2.77-2.8 2.612 2.612 0 0 0 -2.31-2.4s-2.77.4-2.77-1.2-3.27-1.6-3.27-1.6c-2.29 0-3.65 1.43-3.65 3.2 0 2.65 1.65 4.8 3.69 4.8zm-9.69-12.13c2.79-1.72 7.21-3.87 12-3.87 8 0 13 6 13 6v37s-7-5-15-5a27.145 27.145 0 0 0 -13 3v-35a26.423 26.423 0 0 1 3-2.13z",
    fill: "#ffe8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 39c0-8-8-8-8-8 0 8 8 8 8 8zm1-8c0 8 8 8 8 8 0-8-8-8-8-8zm9-19.13a26.423 26.423 0 0 1 3 2.13v35a27.145 27.145 0 0 0 -13-3c-8 0-15 5-15 5v-37a12.821 12.821 0 0 1 1-1.03 19.606 19.606 0 0 1 3-2.29 16.946 16.946 0 0 1 9-2.68c4.79 0 9.21 2.15 12 3.87z",
    fill: "#ffebc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 51c-7 0-15 3-15 3v2s8-3 15-3a17.453 17.453 0 0 1 9.452 3h2.548s-4.93-5-12-5z",
    fill: "#696157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 51c-7.07 0-12 5-12 5h2.548a17.453 17.453 0 0 1 9.452-3c7 0 15 3 15 3v-2s-8-3-15-3z",
    fill: "#696157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 56c0-1.11-1.79-2-4-2s-4 .89-4 2h-21v2h21c0-1.11 1.79-2 4-2s4 .89 4 2h21v-2z",
    fill: "#a64f3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 11s-5-6-13-6c-4.79 0-9.21 2.15-12 3.87v3c2.79-1.72 7.21-3.87 12-3.87 8 0 13 6 13 6a12.821 12.821 0 0 1 1-1.03v-2.47a1.479 1.479 0 0 1 .171-.682c-.055.049-.12.105-.171.152a12.821 12.821 0 0 0 -1 1.03z",
    fill: "#a64f3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 5a16.946 16.946 0 0 0 -9 2.68 18.942 18.942 0 0 0 -1.966 1.4 1.482 1.482 0 0 1 1.966 1.42v.18a16.946 16.946 0 0 1 9-2.68c4.79 0 9.21 2.15 12 3.87v-3c-2.79-1.72-7.21-3.87-12-3.87z",
    fill: "#a64f3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 51s-7-5-15-5a27.145 27.145 0 0 0 -13 3v-34l-2 1.333v35.667s9.932-4.563 15-4a27.436 27.436 0 0 1 13.957 6.077 7.774 7.774 0 0 1 1.043-.077z",
    fill: "#c1c4aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 52v-35.667l-2-1.333v34a27.145 27.145 0 0 0 -13-3c-8 0-15 5-15 5v3a7.774 7.774 0 0 1 1.043.077 27.436 27.436 0 0 1 13.957-6.077c5.068-.563 15 4 15 4z",
    fill: "#d0d4b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.719 42.511a20.271 20.271 0 0 1 -6.247-2.559c-.157.015-.31.048-.472.048a5 5 0 0 1 -5-5c0-.024.007-.043.007-.067a19.849 19.849 0 0 1 -4.007-11.955v-12.237c-.728.38-1.407.764-2 1.129a26.423 26.423 0 0 0 -3 2.13v35a27.145 27.145 0 0 1 13-3c8 0 15 5 15 5v-6a36.532 36.532 0 0 0 -7.281-2.489z",
    fill: "#edd39c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.719 42.511a20.241 20.241 0 0 1 -7.719-3.565v.054s-8 0-8-8a9.409 9.409 0 0 1 1.789.231 19.863 19.863 0 0 1 -1.789-8.253v-13.814a18.45 18.45 0 0 0 -3 1.516 19.606 19.606 0 0 0 -3 2.29 12.821 12.821 0 0 0 -1 1.03v37s7-5 15-5a27.145 27.145 0 0 1 13 3v-4.853a35.982 35.982 0 0 0 -5.281-1.636z",
    fill: "#f0daad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.92 17.6c0 1.6 2.77 1.2 2.77 1.2a2.612 2.612 0 0 1 2.31 2.4 2.783 2.783 0 0 1 -2.77 2.8h-5.54c-2.04 0-3.69-2.15-3.69-4.8 0-1.77 1.36-3.2 3.65-3.2 0 0 3.27 0 3.27 1.6z",
    fill: "#ea735c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 31c2.76 0 5 1.24 5 4a5 5 0 0 1 -10 0c0-2.76 2.24-4 5-4z",
    fill: "#e84655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 31 8 8s-8 0-8-8z",
    fill: "#658f41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 31 8 8s-8 0-8-8z",
    fill: "#658f41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 39-8-8s8 0 8 8z",
    fill: "#96b343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 39-8-8s8 0 8 8z",
    fill: "#96b343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.69 18.8s-2.77.4-2.77-1.2-3.27-1.6-3.27-1.6c-2.29 0-3.65 1.43-3.65 3.2 0 2.65 1.65 4.8 3.69 4.8h5.54a2.783 2.783 0 0 0 2.77-2.8 2.612 2.612 0 0 0 -2.31-2.4zm-.46 4.2h-5.54c-1.458 0-2.69-1.74-2.69-3.8 0-1.337 1.04-2.2 2.65-2.2 1.148 0 2.27.379 2.27.6a1.993 1.993 0 0 0 .695 1.553 4.379 4.379 0 0 0 3.122.65 1.67 1.67 0 0 1 1.263 1.397 1.788 1.788 0 0 1 -1.77 1.8z",
    fill: "#bd4c3d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    fill: "#ffd0c9",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 38a5 5 0 0 1 -5-5 4.377 4.377 0 0 1 .071-.676 3.579 3.579 0 0 0 -1.071 2.676 4.993 4.993 0 0 0 9.855 1.147 4.967 4.967 0 0 1 -3.855 1.853z",
    fill: "#c43b48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.5 29.411v-2.411h-1v2.157a7.025 7.025 0 0 0 -3.5-.657v1c3.084 0 3.5.758 3.5 1.5h1c0-.708 1.5-1.5 3.5-1.5v-1a6.283 6.283 0 0 0 -3.5.911z",
    fill: "#537134"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.577,
    cy: 33.708,
    fill: "#f6fafd",
    rx: 0.825,
    ry: 1.148,
    transform: "matrix(.707 -.707 .707 .707 -17.811 24.436)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#918778"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56 20.5a.508.508 0 0 1 -.186-.036 30.7 30.7 0 0 0 -9.814-1.964c-4.826 0-6.758.938-6.776.947a.5.5 0 1 1 -.448-.894c.086-.043 2.164-1.053 7.224-1.053a31.164 31.164 0 0 1 10.186 2.036.5.5 0 0 1 -.186.964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 23.5a.508.508 0 0 1 -.186-.036 30.7 30.7 0 0 0 -9.814-1.964c-4.826 0-6.758.938-6.776.947a.5.5 0 1 1 -.448-.894c.086-.043 2.164-1.053 7.224-1.053a31.164 31.164 0 0 1 10.186 2.036.5.5 0 0 1 -.186.964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 26.5a.508.508 0 0 1 -.186-.036 30.7 30.7 0 0 0 -9.814-1.964c-4.826 0-6.758.938-6.776.947a.5.5 0 1 1 -.448-.894c.086-.043 2.164-1.053 7.224-1.053a31.164 31.164 0 0 1 10.186 2.036.5.5 0 0 1 -.186.964z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m36.962 10.119a2.5 2.5 0 0 0 -4.962.381v3.5a12.821 12.821 0 0 1 1-1.03c.275-.255.619-.551 1-.861v-1.609a.5.5 0 0 1 1 0v33.5a1 1 0 0 0 2 0v-33.5a2.522 2.522 0 0 0 -.038-.381z",
    fill: "#96b343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 44v-33.5a1.5 1.5 0 0 0 -3 0v.5a1 1 0 0 1 -1 1v2a12.821 12.821 0 0 1 1-1.03c.275-.255.619-.551 1-.861v-1.609a.5.5 0 0 1 1 0v33.5a1 1 0 0 0 1 1 .977.977 0 0 0 .5-.153.987.987 0 0 1 -.5-.847z",
    fill: "#658f41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.451 11.134a1.341 1.341 0 0 0 -.45.849 1.27 1.27 0 0 0 .27.771 5.051 5.051 0 0 0 1.929 1.406 14.037 14.037 0 0 1 4.827 3.846 27.337 27.337 0 0 0 2.441 3.376 1.511 1.511 0 0 0 1.591.534 1.218 1.218 0 0 0 .454-.4 3.969 3.969 0 0 0 .487-2.359q-.009-1.265-.063-2.528a6.739 6.739 0 0 0 -.209-1.618 5.119 5.119 0 0 0 -1.843-2.447c-2.273-1.82-6.962-3.905-9.434-1.43z",
    fill: "#fff3db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.669 10.08a3.124 3.124 0 0 0 -2.644 2.3 1.611 1.611 0 0 0 .23 1.182 2.176 2.176 0 0 0 .686.579 19.207 19.207 0 0 0 5.312 1.686 33.243 33.243 0 0 1 3.689 1.192c1.033.394 2.222 1.235 3.337.911a1.12 1.12 0 0 0 .455-.226c.5-.461.177-1.728-.046-2.254-1.017-2.4-3.965-3.862-6.34-4.65a9.793 9.793 0 0 0 -4.679-.72z",
    fill: "#fff3db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 60v3h2a2 2 0 0 1 2-2h42a2 2 0 0 1 2 2h2v-3z",
    fill: "#471e17"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.c64df536.svg";
export { ForwardRef as ReactComponent };